var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('nav-bar',{attrs:{"app":this}}),_c('side-bar',{attrs:{"app":this}}),_c('v-main',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }